import { render, staticRenderFns } from "./SocialOrganicInstagramGrid.vue?vue&type=template&id=2f4b409a"
import script from "./SocialOrganicInstagramGrid.vue?vue&type=script&lang=js"
export * from "./SocialOrganicInstagramGrid.vue?vue&type=script&lang=js"
import style0 from "./SocialOrganicInstagramGrid.vue?vue&type=style&index=0&id=2f4b409a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports